import React, { useContext, useRef, useEffect, useState} from 'react';
import useSignalR from '../useSignalR';

import { LockerManagementContext } from '@/context/LockerManagmentContext';
import { LockerContextRefreshType as Table, LockerEventStatus } from  '@/interfaces/LockerManagement';

interface BatchEventMessage {
    BatchId: string
    BatchIntentFileCount: number
    BatchIntentUserCount: number
    BatchLastUpdate: string
    BatchStatus:  LockerEventStatus
    OrganizationId: number
}

const useBatchIngestNotificaitons = ({orgId, table, refreshTimeout}: {orgId: number, table: Table, refreshTimeout: number }) => {
    // used for throttling websocket requests
    const lastExecuted = useRef<number>(Date.now());
    const [message, setMessage] = useState<BatchEventMessage>();

    const { events, setEvents, refreshData } = useContext(LockerManagementContext);

    useEffect(()=> {
        if (message) {
            let parsedmessage = message
            let existingBatchIndex = -1;
            if (typeof message === 'string' && table === Table.EVENTS) {
                parsedmessage = JSON.parse(parsedmessage as unknown as string)
                if(parsedmessage.BatchId) {
                    existingBatchIndex = events.findIndex(event => event.lockerBatchName === parsedmessage.BatchId)
                }
            }

            const { OrganizationId, BatchStatus } = parsedmessage;

            // if updating an existing batch - patch changes into events, 
            if (existingBatchIndex >= 0 ) {
                let updatedEvent = {
                    ...events[existingBatchIndex],
                    intentAliasCount: parsedmessage.BatchIntentUserCount,
                    intentFileCount: parsedmessage.BatchIntentFileCount,
                    lockerBatchStatus: 20
                }
                setEvents(events.map((event, idx) => {
                    if (idx === existingBatchIndex) {
                        return updatedEvent
                    }
                    return event;
                }));
            }
            // otherwise referesh and throttle to get latest events from server
            else if (OrganizationId === orgId && (table === Table.EVENTS || BatchStatus === LockerEventStatus.COMPLETED)) {
                if (Date.now() >= lastExecuted.current + refreshTimeout) {
                    lastExecuted.current = Date.now();
                    refreshData(table);

                }else {
                    const throttleTimer = setTimeout(() => {
                      lastExecuted.current = Date.now()
                      refreshData(table);
                    }, refreshTimeout)
              
                    return () => clearTimeout(throttleTimer)
                  }
            }
        }
    }, [message])

    useSignalR({
        connectionString: '/hubs/clientnotifications',
        connectionMethods: [
           { method: 'BatchIngestUpdate', newMethod: (message: BatchEventMessage) => setMessage(message)}
        ],
        reconnectCallBack: () => console.log('reconnected'),
        connectionCloseCallback: () => console.log('connection closed'),
    });
}

export default useBatchIngestNotificaitons;
